import React from 'react'

const Box = () => {
  return (
    <div>

    </div>
  )
}

export default Box